import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shopflo/ui'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { InputSlider } from 'src/components/common/slider/InputSlider'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { BORDER_SIDES_OPTIONS, BorderSides } from '../config'
import { SLIDER_CONSTANTS } from 'src/lib/utils/constants'

export const OrderSummaryControl = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()

  const handleConfigChange = (updates: Record<string, any>) => {
    setCartUIConfigData(updates, 'ORDER_SUMMARY')
  }

  return (
    <div className='flex flex-col gap-3'>
      <div className='flex flex-col gap-2 mb-4'>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Background'
            color={cartUIData.orderSummaryConfig.backgroundColor}
            onChange={color => handleConfigChange({ backgroundColor: color })}
          />
          <ColorPickerV2
            label='Border'
            color={cartUIData.orderSummaryConfig.borderColor}
            onChange={color => handleConfigChange({ borderColor: color })}
          />
        </div>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Offer badge'
            color={cartUIData.orderSummaryConfig.offerBadgeColor}
            onChange={color => handleConfigChange({ offerBadgeColor: color })}
          />
          <ColorPickerV2
            label='Text'
            color={cartUIData.orderSummaryConfig.textColor}
            onChange={color => handleConfigChange({ textColor: color })}
          />
        </div>
      </div>

      <div className='flex flex-col gap-3 mb-2'>
        <p className='text-text-xs-medium text-zinc-500'>Quantity Editor</p>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Background'
            color={cartUIData.orderSummaryConfig.quantityEditorBackground}
            onChange={color => handleConfigChange({ quantityEditorBackground: color })}
          />
          <ColorPickerV2
            label='Text'
            color={cartUIData.orderSummaryConfig.quantityEditorText}
            onChange={color => handleConfigChange({ quantityEditorText: color })}
          />
        </div>
      </div>

      <div className='border-t border-zinc-950/6' />

      <InputSlider
        label='Card radius'
        value={cartUIData.orderSummaryConfig.cardRadius}
        onChange={value => handleConfigChange({ cardRadius: value })}
        min={0}
        max={SLIDER_CONSTANTS.MAX_RADIUS}
        step={1}
        showDots={true}
        dotCount={5}
        unit='px'
      />

      <div className='flex flex-col gap-1'>
        <InputSlider
          label='Card border'
          value={cartUIData.orderSummaryConfig.cardBorderWidth}
          onChange={value => handleConfigChange({ cardBorderWidth: value })}
          min={0}
          max={SLIDER_CONSTANTS.MAX_BORDER_WIDTH}
          step={1}
          showDots={true}
          dotCount={5}
          unit='px'
        />

        <div className='flex items-center justify-end gap-2 mt-1'>
          <Select
            value={cartUIData.orderSummaryConfig.cardBorderSides}
            onValueChange={(value: BorderSides) => handleConfigChange({ cardBorderSides: value })}
          >
            <SelectTrigger className='w-[178px] h-8 bg-white'>
              <SelectValue placeholder='Select sides' />
            </SelectTrigger>
            <SelectContent>
              {BORDER_SIDES_OPTIONS.map(option => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
